// Supported languages configuration
export const SUPPORTED_LANGUAGES = {
  cs: {
    code: 'cs',
    name: 'Čeština',
    locale: 'cs-CZ',
    flag: '🇨🇿',
    currency: 'CZK'
  },
  en: {
    code: 'en',
    name: 'English',
    locale: 'en-US',
    flag: '🇬🇧',
    currency: 'EUR'
  }
};

export const DEFAULT_LANGUAGE = 'cs';
export const LANGUAGE_STORAGE_KEY = 'preferred_language';

// Get array of language codes for validation
export const LANGUAGE_CODES = Object.keys(SUPPORTED_LANGUAGES);

// Helper to check if language code is supported
export const isValidLanguage = (code) => LANGUAGE_CODES.includes(code);

// Get language config by code with fallback
export const getLanguageConfig = (code) => {
  return SUPPORTED_LANGUAGES[code] || SUPPORTED_LANGUAGES[DEFAULT_LANGUAGE];
};
